<template>
  <div v-if="visible" ref="alert" class="cp-alert">
    <div class="box-mask">
      <div class="box-container">
        <!-- <div class="box-header">
          <div class="box-title">{{ title }}</div>
        </div> -->
        <div class="box-content" v-html="text"></div>
        <div class="box-bottom">
          <div class="bottom-item" @click="onClose"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  data() {
    return {
      visible: false,
      title: '',
      text: '',
      promiseStatus: null
    }
  },
  methods: {
    confirm() {
      let _this = this;
      this.visible = true;
      return new Promise(function(resolve, reject) {
        _this.promiseStatus = { resolve, reject };
      });
    },
    onClose() {
      this.$refs.alert.className += ' fadeOut';
      let t = setTimeout(() => {
        this.visible = false;
        clearTimeout(t);
        this.promiseStatus.resolve('ok');
      }, 300);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .cp-alert{
    text-align: center;
    color: #2c3e50;
    height: 100%;
    font-size: .32rem;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index 2001
    top 0
    animation fadeIn 0.3s ease-in-out
    &.fadeOut {
      animation fadeOut 0.3s ease-in-out
      animation-fill-mode forwards
    }
    .box-mask{
      z-index: 900;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,.75);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .box-container{
    position absolute
    width 6.92rem
    height 3.91rem
    top 50%
    left 0.29rem
    margin-top -1.955rem
    background-image url('./images/alert.png')
    background-size: contain;
    background-repeat: no-repeat;
    background-position 0 0
    animation fadeIn 0.3s ease-in-out
    display: flex;
    flex-direction: column;
    justify-content: center;
    .box-header {
      padding-top: 0.25rem;
    }
    .box-title {
      text-align: center;
      padding-left: 0;
      margin-bottom: 0;
      font-size: 0.32rem;
      font-weight: 700;
      color: #333;
      letter-spacing 0.04rem
    }
    .box-content{
      word-break: break-all;
      line-height: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size 0.3rem;
      color: #000;
      font-weight bold;
      width: 79%;
      margin: 0 auto;
    }
    .box-bottom{
      // border-top: 1px solid #ddd;
      width: 100%;
      height: 0.8rem;
      line-height 0.8rem
      display: flex;
      align-items: center;
      justify-content: center;
      color: #26a2ff;
      letter-spacing 0.04rem;
      margin-top 0.72rem;
      // top 2.82rem
      // position absolute
      .bottom-item {
        width: 2.27rem;
        height: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-image url('./images/me.png')
        background-size contain
      }
    }
  }
  @keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
  }
  @keyframes fadeOut {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
  }
</style>
